export default "__VITE_ASSET__drQXJ25E__"